export default {
  error: 'Error',
  close: 'Close',

  loadTextFile: 'Load Text File',
  lines: 'Lines of Subtitle: no line | Lines of Subtitle: {n} line | Lines of Subtitle: {n} lines',
  startEditing: 'Start Editing',
  reactTime: 'React Time: ',
  currentLine: 'Current Line',
  emptyHint: '[Empty]',
  comingLines: 'Coming Lines',
  eofHint: '[End of File]',
  startReviewing: 'Start Reviewing',
  updatePreview: 'Update Preview',
  saveSrt: 'Save in SRT Format',
  saveVtt: 'Save in WebVTT Format',
  loadMedia: 'Load Audio / Video',

  emptySubtitle: 'Subtitle cannot be empty',
  invalidSrt: 'SRT file is invalid',

  shortcuts: 'Operations',
  shortcutK: 'Switch to Next Line',
  shortcutL: 'Stop Current Line',
  shortcutU: 'Prev 3 Secs',
  shortcutP: 'Skip 3 Secs',
  shortcutI: 'Prev Line',
  shortcutO: 'Skip Line',
  shortcutR: 'Pause / Resume',
  shortcutQ: 'Slow Down',
  shortcutE: 'Speed Up',
};



// WEBPACK FOOTER //
// ./src/i18n/en.js